export default class Enhancer {
    element = null;
    application = null;

    constructor(element) {
        this.element = element;
    }

    getData(name) {
        return this.element.getAttribute(`data-${name}`);
    }

    setData(name, value) {
        return this.element.setAttribute(`data-${name}`, value);
    }

    get(selector) {
        return this.element.querySelector(selector);
    }

    getAll(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
}
